// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Button Animations and Styles */
@keyframes glow {
  0% { 
    box-shadow: 0 0 12px rgba(130, 147, 183, 0.9), 0 0 18px rgba(187, 125, 245, 0.7); 
  }
  50% { 
    box-shadow: 0 0 18px rgba(100, 150, 255, 1), 0 0 25px rgba(180, 100, 255, 0.9); 
  }
  100% { 
    box-shadow: 0 0 12px rgba(104, 137, 207, 0.9), 0 0 18px rgba(180, 100, 255, 0.7); 
  }
}

/* Sand Timer Animation */
@keyframes sandPour {
  0% {
    transform: rotate(0deg);
    color: #ff4d4f;
  }
  50% {
    transform: rotate(180deg);
    color: #ff7878;
  }
  100% {
    transform: rotate(360deg);
    color: #ff4d4f;
  }
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  font-size: 16px;
  font-weight: 600;
  color: #6B21A8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  border-radius: 30px;
  border: 2px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  transition: all 0.4s ease;
  font-family: 'Roboto', sans-serif;
  min-width: 50px;
}

.custom-button:hover:enabled {
  transform: scale(1.05);
  animation: glow 1.5s ease-in-out infinite;
}

.custom-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e8e8e8;
  color: #b0b0b0;
  background-image: none;
  box-shadow: none;
  font-family: 'Roboto', sans-serif;
}

/* Start Screen Button */
.start-screen .custom-button.ant-btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: 600;
  color: #6B21A8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  border-radius: 30px;
  border: 2px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  transition: all 0.4s ease;
  font-family: 'Roboto', sans-serif;
}

.start-screen .custom-button.ant-btn-primary:hover,
.start-screen .custom-button.ant-btn-primary:focus {
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  color: #6B21A8;
  transform: scale(1.05);
  animation: glow 1.5s ease-in-out infinite;
  font-family: 'Roboto', sans-serif;
}

/* Modal OK Button */
.ant-modal .ant-btn.ant-btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 15px;
  font-size: 14px;
  font-weight: 600;
  color: #6B21A8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  border-radius: 30px;
  border: 2px solid transparent;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  transition: all 0.4s ease;
  font-family: 'Roboto', sans-serif;
}

.ant-modal .ant-btn.ant-btn-primary:hover,
.ant-modal .ant-btn.ant-btn-primary:focus {
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  color: #6B21A8;
  transform: scale(1.05);
  animation: glow 1.5s ease-in-out infinite;
  font-family: 'Roboto', sans-serif;
}

.ant-modal .ant-btn.ant-btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #e8e8e8;
  color: #b0b0b0;
  background-image: none;
  box-shadow: none;
  font-family: 'Roboto', sans-serif;
}

/* Modal Customization */
.ant-modal-title {
  text-align: center;
  color: #6B21A8 !important;
  font-family: 'Roboto', sans-serif;
}

.ant-modal-body {
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

.ant-modal-footer {
  padding: 20px !important;
  display: flex;
  justify-content: center;
  min-height: 60px;
}

/* Modal Centering */
.ant-modal {
  width: 350px !important;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
}

.ant-modal-header {
  padding: 16px !important;
}

.ant-modal-body {
  padding: 16px !important;
}

.modal-text {
  margin-bottom: 12px;
  font-family: 'Roboto', sans-serif;
}

/* Button Container */
.button-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  min-height: 40px;
  align-items: center;
}

/* Layout Components */
.main-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  background-image: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
  overflow: hidden;
}

.main-container.fullscreen-active {
  padding-top: 0;
}

.main-container.fullscreen-inactive {
  padding-top: 0;
}

/* Combined Exam Card */
.exam-card {
  background-color: #fff;
  padding: 1rem;
  border-radius: 12px;
  border: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90vw;
  height: 90vh;
  margin: 4vh 4vw 4vh 4vw;
  max-width: 90vw;
  max-height: 90vh;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* Footer */
.exam-footer {
  display: flex;
  justify-content: space-between; /* Center question-button-group, right-align submit-button */
  align-items: center;
  padding: 20px;
  background-color: #fff;
}

.question-button-group {
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding: 1rem;
  flex: 3 1; /* Matches question-section flex ratio */
  max-width: calc(90vw * 0.7); /* Matches question-card width */
}

.submit-button {
  margin-right: 6rem; /* Align to right corner with padding */
}

/* Header */
.fixed-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1;
  padding: 0.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none;
}

.header-left {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
}

.header-center {
  flex: 1 1;
  display: flex;
  justify-content: center;
}

.header-right {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  padding-right: 20px;
}

.fixed-header h4 {
  font-weight: 600;
  font-size: 24px;
  color: #552095;
  margin: 0;
  font-family: 'Roboto', sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.timer-display {
  font-size: 18px;
  font-weight: 600;
  color: #ff4d4f;
  font-family: 'Roboto', sans-serif;
  display: flex;
  align-items: center;
}

.sand-timer-icon {
  margin-right: 8px;
  animation: sandPour 2s ease-in-out infinite;
}

.violation-display {
  font-size: 14px;
  color: #666;
  font-family: 'Roboto', sans-serif;
}

/* Content Wrapper for Side-by-Side Layout */
.content-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  overflow: hidden;
}

/* Question Section (Left Side) */
.question-section {
  flex: 3 1;
  padding-right: 1rem;
  display: flex;
  flex-direction: column;
}

/* Question Card */
.question-card {
  background-color: #F5F5F5;
  border: 1px solid #ddd;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  width: 100%;
  max-width: calc(90vw * 0.7);
  height: calc(90vh * 0.75);
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-top: 20px;
  overflow-y: auto;
}

/* Question Number */
.question-number {
  font-weight: 600;
  font-size: 24px;
  color: #552095;
  margin-bottom: 1rem;
  font-family: 'Roboto', sans-serif;
}

/* Navigator Section (Right Side) */
.navigator-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: none;
  padding-left: 1rem;
  margin-top: 1.5rem;
  max-height: calc(90vh - 40px - 40px - 48px - 16px);
}

/* Navigator Title */
.navigator-title {
  font-size: 24px;
  font-weight: 600;
  color: #552095;
  margin-bottom: 1rem;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

/* Navigator Buttons Container */
.navigator-button-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(6, 1fr);
  gap: 0.3rem;
  max-height: calc(90vh - 40px - 40px - 48px - 24px - 40px - 40px - 16px);
  overflow-y: auto;
  padding-right: 5px;
  width: 100%;
  justify-items: center;
}

/* Navigator Button */
.navigator-button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  color: #6B21A8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  transition: all 0.4s ease;
  font-family: 'Roboto', sans-serif;
}

.navigator-button.current {
  background-color: #1890ff;
  color: #fff;
  background-image: none;
  font-family: 'Roboto', sans-serif;
}

.navigator-button.answered {
  background-color: #52c41a;
  color: #fff;
  background-image: none;
  font-family: 'Roboto', sans-serif;
}

.navigator-button.unanswered {
  background-color: #f0f0f0;
  color: #6B21A8;
  background-image: none;
  font-family: 'Roboto', sans-serif;
}

/* Pagination Buttons */
.pagination-container {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1rem; /* Increased gap from navigator buttons */
  margin-bottom: 1rem; /* Gap from indicators */
}

/* Indicator Section */
.indicator-container {
  display: flex;
  flex-direction: row; /* Horizontal layout */
  align-items: center;
  gap: 1rem; /* Spacing between indicators */
  padding: 0.5rem;
  background-color: transparent;
}

.indicator {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  cursor: pointer;
  padding: 5px;
  transition: background-color 0.3s ease;
}

.indicator.selected {
  background-color: #e6f7ff; /* Highlight selected indicator */
  border-radius: 4px;
}

.indicator:hover {
  background-color: #f0f0f0;
}

.indicator-box {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.indicator-box.current {
  background-color: #1890ff;
}

.indicator-box.answered {
  background-color: #52c41a;
}

.indicator-box.unanswered {
  background-color: #f0f0f0;
}

.indicator-text {
  font-size: 0.875rem;
  font-family: 'Roboto', sans-serif;
}

/* Question Content */
.scrollable-content {
  flex: 1 1;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: calc(90vh * 0.75 - 24px - 16px - 40px - 1.5rem);
  scrollbar-width: thin;
  scrollbar-color: #6c757d #f8f9fa;
}

.scrollable-content::-webkit-scrollbar {
  width: 12px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 6px;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: #6c757d;
  border-radius: 6px;
  border: 2px solid #f8f9fa;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: #495057;
}

.question-text {
  margin-bottom: 1rem;
  margin-left: 3rem;
  font-size: 26px;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
}

.options-scrollable {
  margin-bottom: 1rem;
}

.option-card {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 1rem;
  margin-bottom: 0.75rem;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  min-height: 50px;
}

.option-card:hover {
  background-color: #f8f8f8;
  border-color: #ccc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.option-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 18px;
  font-weight: 400;
  color: #333;
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
}

.option-label input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

/* Fullscreen Warning and Error Messages */
.fullscreen-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #ff6b6b;
  color: white;
  padding: 10px;
  text-align: center;
  z-index: 9999;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
}

.fullscreen-warning.hidden {
  display: none;
}

.fullscreen-button {
  margin-left: 15px;
  padding: 5px 15px;
  background-color: white;
  color: #ff6b6b;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
}

.error-message {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffa726;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  z-index: 9998;
  max-width: 90%;
  text-align: center;
  font-size: 13px;
  font-family: 'Roboto', sans-serif;
}

.error-message.fullscreen-active {
  margin-top: 0;
}

.error-message.fullscreen-inactive {
  margin-top: 50px;
}

.error-close-button {
  margin-left: 10px;
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 2px 8px;
  border-radius: 2px;
  cursor: pointer;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
}

/* Debug Info */
.debug-info {
  margin-top: 10px;
  background-color: rgb(253, 253, 253);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 11px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
}

/* Start Screen */
.start-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 20px;
  background-image: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);
}

.start-screen h2 {
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
}

.start-screen p {
  margin-bottom: 30px;
  max-width: 600px;
  font-family: 'Roboto', sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/pages/TakeTestPage.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE;IACE,gFAAgF;EAClF;EACA;IACE,8EAA8E;EAChF;EACA;IACE,gFAAgF;EAClF;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yGAAyG;EACzG,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yGAAyG;EACzG,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;EAEE,yGAAyG;EACzG,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,yGAAyG;EACzG,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;;EAEE,yGAAyG;EACzG,cAAc;EACd,sBAAsB;EACtB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sEAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B,EAAE,4DAA4D;EAC5F,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,SAAO,EAAE,wCAAwC;EACjD,2BAA2B,EAAE,gCAAgC;AAC/D;;AAEA;EACE,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,SAAS;EACT,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iCAAiC;AACnC;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,WAAW;EACX,uEAAuE;EACvE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yGAAyG;EACzG,6BAA6B;EAC7B,wCAAwC;EACxC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB,EAAE,yCAAyC;EAC3D,mBAAmB,EAAE,wBAAwB;AAC/C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB,EAAE,sBAAsB;EAC3C,mBAAmB;EACnB,SAAS,EAAE,+BAA+B;EAC1C,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;EAC5D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;EAC3D,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;AACnC","sourcesContent":["/* Button Animations and Styles */\n@keyframes glow {\n  0% { \n    box-shadow: 0 0 12px rgba(130, 147, 183, 0.9), 0 0 18px rgba(187, 125, 245, 0.7); \n  }\n  50% { \n    box-shadow: 0 0 18px rgba(100, 150, 255, 1), 0 0 25px rgba(180, 100, 255, 0.9); \n  }\n  100% { \n    box-shadow: 0 0 12px rgba(104, 137, 207, 0.9), 0 0 18px rgba(180, 100, 255, 0.7); \n  }\n}\n\n/* Sand Timer Animation */\n@keyframes sandPour {\n  0% {\n    transform: rotate(0deg);\n    color: #ff4d4f;\n  }\n  50% {\n    transform: rotate(180deg);\n    color: #ff7878;\n  }\n  100% {\n    transform: rotate(360deg);\n    color: #ff4d4f;\n  }\n}\n\n.custom-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 15px;\n  font-size: 16px;\n  font-weight: 600;\n  color: #6B21A8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 2px solid transparent;\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  transition: all 0.4s ease;\n  font-family: 'Roboto', sans-serif;\n  min-width: 50px;\n}\n\n.custom-button:hover:enabled {\n  transform: scale(1.05);\n  animation: glow 1.5s ease-in-out infinite;\n}\n\n.custom-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #e8e8e8;\n  color: #b0b0b0;\n  background-image: none;\n  box-shadow: none;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Start Screen Button */\n.start-screen .custom-button.ant-btn-primary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 15px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6B21A8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 2px solid transparent;\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  transition: all 0.4s ease;\n  font-family: 'Roboto', sans-serif;\n}\n\n.start-screen .custom-button.ant-btn-primary:hover,\n.start-screen .custom-button.ant-btn-primary:focus {\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  color: #6B21A8;\n  transform: scale(1.05);\n  animation: glow 1.5s ease-in-out infinite;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Modal OK Button */\n.ant-modal .ant-btn.ant-btn-primary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 5px 15px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #6B21A8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 2px solid transparent;\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  transition: all 0.4s ease;\n  font-family: 'Roboto', sans-serif;\n}\n\n.ant-modal .ant-btn.ant-btn-primary:hover,\n.ant-modal .ant-btn.ant-btn-primary:focus {\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  color: #6B21A8;\n  transform: scale(1.05);\n  animation: glow 1.5s ease-in-out infinite;\n  font-family: 'Roboto', sans-serif;\n}\n\n.ant-modal .ant-btn.ant-btn-primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background: #e8e8e8;\n  color: #b0b0b0;\n  background-image: none;\n  box-shadow: none;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Modal Customization */\n.ant-modal-title {\n  text-align: center;\n  color: #6B21A8 !important;\n  font-family: 'Roboto', sans-serif;\n}\n\n.ant-modal-body {\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n.ant-modal-footer {\n  padding: 20px !important;\n  display: flex;\n  justify-content: center;\n  min-height: 60px;\n}\n\n/* Modal Centering */\n.ant-modal {\n  width: 350px !important;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) !important;\n  margin: 0 !important;\n}\n\n.ant-modal-header {\n  padding: 16px !important;\n}\n\n.ant-modal-body {\n  padding: 16px !important;\n}\n\n.modal-text {\n  margin-bottom: 12px;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Button Container */\n.button-container {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  min-height: 40px;\n  align-items: center;\n}\n\n/* Layout Components */\n.main-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n  box-sizing: border-box;\n  background-image: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n  overflow: hidden;\n}\n\n.main-container.fullscreen-active {\n  padding-top: 0;\n}\n\n.main-container.fullscreen-inactive {\n  padding-top: 0;\n}\n\n/* Combined Exam Card */\n.exam-card {\n  background-color: #fff;\n  padding: 1rem;\n  border-radius: 12px;\n  border: none;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  width: 90vw;\n  height: 90vh;\n  margin: 4vh 4vw 4vh 4vw;\n  max-width: 90vw;\n  max-height: 90vh;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Footer */\n.exam-footer {\n  display: flex;\n  justify-content: space-between; /* Center question-button-group, right-align submit-button */\n  align-items: center;\n  padding: 20px;\n  background-color: #fff;\n}\n\n.question-button-group {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  padding: 1rem;\n  flex: 3; /* Matches question-section flex ratio */\n  max-width: calc(90vw * 0.7); /* Matches question-card width */\n}\n\n.submit-button {\n  margin-right: 6rem; /* Align to right corner with padding */\n}\n\n/* Header */\n.fixed-header {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 1;\n  padding: 0.5rem 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: none;\n}\n\n.header-left {\n  flex: 1;\n  display: flex;\n  justify-content: flex-start;\n  padding-left: 20px;\n}\n\n.header-center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n}\n\n.header-right {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  padding-right: 20px;\n}\n\n.fixed-header h4 {\n  font-weight: 600;\n  font-size: 24px;\n  color: #552095;\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.timer-display {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ff4d4f;\n  font-family: 'Roboto', sans-serif;\n  display: flex;\n  align-items: center;\n}\n\n.sand-timer-icon {\n  margin-right: 8px;\n  animation: sandPour 2s ease-in-out infinite;\n}\n\n.violation-display {\n  font-size: 14px;\n  color: #666;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Content Wrapper for Side-by-Side Layout */\n.content-wrapper {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  overflow: hidden;\n}\n\n/* Question Section (Left Side) */\n.question-section {\n  flex: 3;\n  padding-right: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Question Card */\n.question-card {\n  background-color: #F5F5F5;\n  border: 1px solid #ddd;\n  border-radius: 12px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  width: 100%;\n  max-width: calc(90vw * 0.7);\n  height: calc(90vh * 0.75);\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  margin-top: 20px;\n  overflow-y: auto;\n}\n\n/* Question Number */\n.question-number {\n  font-weight: 600;\n  font-size: 24px;\n  color: #552095;\n  margin-bottom: 1rem;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Navigator Section (Right Side) */\n.navigator-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-left: none;\n  padding-left: 1rem;\n  margin-top: 1.5rem;\n  max-height: calc(90vh - 40px - 40px - 48px - 16px);\n}\n\n/* Navigator Title */\n.navigator-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #552095;\n  margin-bottom: 1rem;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Navigator Buttons Container */\n.navigator-button-container {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(6, 1fr);\n  gap: 0.3rem;\n  max-height: calc(90vh - 40px - 40px - 48px - 24px - 40px - 40px - 16px);\n  overflow-y: auto;\n  padding-right: 5px;\n  width: 100%;\n  justify-items: center;\n}\n\n/* Navigator Button */\n.navigator-button {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6B21A8;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  background-image: linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF);\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n  transition: all 0.4s ease;\n  font-family: 'Roboto', sans-serif;\n}\n\n.navigator-button.current {\n  background-color: #1890ff;\n  color: #fff;\n  background-image: none;\n  font-family: 'Roboto', sans-serif;\n}\n\n.navigator-button.answered {\n  background-color: #52c41a;\n  color: #fff;\n  background-image: none;\n  font-family: 'Roboto', sans-serif;\n}\n\n.navigator-button.unanswered {\n  background-color: #f0f0f0;\n  color: #6B21A8;\n  background-image: none;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Pagination Buttons */\n.pagination-container {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 1rem; /* Increased gap from navigator buttons */\n  margin-bottom: 1rem; /* Gap from indicators */\n}\n\n/* Indicator Section */\n.indicator-container {\n  display: flex;\n  flex-direction: row; /* Horizontal layout */\n  align-items: center;\n  gap: 1rem; /* Spacing between indicators */\n  padding: 0.5rem;\n  background-color: transparent;\n}\n\n.indicator {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  cursor: pointer;\n  padding: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.indicator.selected {\n  background-color: #e6f7ff; /* Highlight selected indicator */\n  border-radius: 4px;\n}\n\n.indicator:hover {\n  background-color: #f0f0f0;\n}\n\n.indicator-box {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.indicator-box.current {\n  background-color: #1890ff;\n}\n\n.indicator-box.answered {\n  background-color: #52c41a;\n}\n\n.indicator-box.unanswered {\n  background-color: #f0f0f0;\n}\n\n.indicator-text {\n  font-size: 0.875rem;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Question Content */\n.scrollable-content {\n  flex: 1;\n  overflow-x: hidden;\n  overflow-y: auto;\n  max-height: calc(90vh * 0.75 - 24px - 16px - 40px - 1.5rem);\n  scrollbar-width: thin;\n  scrollbar-color: #6c757d #f8f9fa;\n}\n\n.scrollable-content::-webkit-scrollbar {\n  width: 12px;\n}\n\n.scrollable-content::-webkit-scrollbar-track {\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb {\n  background: #6c757d;\n  border-radius: 6px;\n  border: 2px solid #f8f9fa;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb:hover {\n  background: #495057;\n}\n\n.question-text {\n  margin-bottom: 1rem;\n  margin-left: 3rem;\n  font-size: 26px;\n  font-weight: 500;\n  font-family: 'Roboto', sans-serif;\n}\n\n.options-scrollable {\n  margin-bottom: 1rem;\n}\n\n.option-card {\n  background-color: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  max-width: 90%;\n  margin-left: auto;\n  margin-right: auto;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n  display: flex;\n  align-items: center;\n  min-height: 50px;\n}\n\n.option-card:hover {\n  background-color: #f8f8f8;\n  border-color: #ccc;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.option-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 18px;\n  font-weight: 400;\n  color: #333;\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.5;\n}\n\n.option-label input[type=\"radio\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n/* Fullscreen Warning and Error Messages */\n.fullscreen-warning {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #ff6b6b;\n  color: white;\n  padding: 10px;\n  text-align: center;\n  z-index: 9999;\n  font-size: 14px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.fullscreen-warning.hidden {\n  display: none;\n}\n\n.fullscreen-button {\n  margin-left: 15px;\n  padding: 5px 15px;\n  background-color: white;\n  color: #ff6b6b;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: bold;\n  font-family: 'Roboto', sans-serif;\n}\n\n.error-message {\n  position: fixed;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #ffa726;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 4px;\n  z-index: 9998;\n  max-width: 90%;\n  text-align: center;\n  font-size: 13px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.error-message.fullscreen-active {\n  margin-top: 0;\n}\n\n.error-message.fullscreen-inactive {\n  margin-top: 50px;\n}\n\n.error-close-button {\n  margin-left: 10px;\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 2px;\n  cursor: pointer;\n  font-size: 11px;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Debug Info */\n.debug-info {\n  margin-top: 10px;\n  background-color: rgb(253, 253, 253);\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 11px;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n}\n\n/* Start Screen */\n.start-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  text-align: center;\n  padding: 20px;\n  background-image: linear-gradient(to right, #EFF6FF, #F3E8FF, #FEE7EF);\n}\n\n.start-screen h2 {\n  margin-bottom: 20px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.start-screen p {\n  margin-bottom: 30px;\n  max-width: 600px;\n  font-family: 'Roboto', sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
